<template>
  <div id="question-view" class="view mobile" :class="{ loading: loading }">
    <div class="next" @click="prevQuestion" v-if="atQuestion > 0">
      <i class="fa fa-angle-left" aria-hidden="true"></i>
      Tillbaka
    </div>
    <div class="top gradient-ani" :style="{ backgroundImage: gradientBackground }">
      <div class="darkness" :style="{ opacity: darknessOpacity }"></div>
      <div class="question-container">
        <h1>Påstående {{ atQuestion + 1 }}</h1>
        <p>{{currentQuestion.text}}</p>
      </div>
      <div
        class="emoji"
        v-html="currentQuestion.emoji_html"
      >
      <!-- http://unicode.org/emoji/charts/full-emoji-list.html -->
      </div>
    </div>
    <div class="bottom">
      <div class="answer-container">
        <div class="reponses">
          <div class="response nej outline" :class="{ active: answered === false  }" @click="nextQuestion(false)">nej</div>
          <div class="response ja" :class="{ active: answered === true  }" @click="nextQuestion(true)">ja</div>
        </div>
        <div><the-karta :atQuestion="atQuestion" /></div>
      </div>
    </div>
  </div>
</template>

<script>
import TWEEN from 'tween.js'
import TheKarta from '@/components/TheKarta'
export default {
  name: 'QuestionView',
  data () {
    return {
      loading: true,
      answered: null,
      currentRotation: 0,
      gradients: [
        ['#fd9b8e', '#ff0846']
      ]
    }
  },
  props: ['atQuestion', 'currentQuestion'],
  computed: {
    darknessOpacity () {
      if (this.atQuestion < 3) return 0
      return ((this.atQuestion + 1) / 16)
    },
    gradientBackground () {
      return 'linear-gradient(' +
        this.currentRotation + 'deg, ' +
        this.gradients[0][0] + ' 0%, ' +
        this.gradients[0][1] + ' 100%)'
    }
  },
  watch: {
    currentRotation () {
      if (this.currentRotation === 360) {
        this.currentRotation = 0
        this.tween(0, 360)
      }
    }
  },
  methods: {
    nextQuestion (answer) {
      this.loading = true
      this.answered = answer
      window.setTimeout(() => {
        this.$emit('answer', answer)
        this.loading = false
        this.answered = null
      }, 500)
    },
    prevQuestion () {
      this.loading = true
      window.setTimeout(() => {
        this.$emit('back')
        this.loading = false
        this.answered = null
      }, 500)
    },
    tween (start, end) {
      let frameHandler = null
      const tweenDuration = 10000
      const animate = function (currentTime) {
        TWEEN.update(currentTime)
        frameHandler = window.requestAnimationFrame(animate)
      }
      new TWEEN.Tween({ tweeningValue: start })
        .to({ tweeningValue: end }, tweenDuration)
        .onUpdate((tweenObj) => {
          this.currentRotation = tweenObj * 360
        })
        .onComplete(() => {
          cancelAnimationFrame(frameHandler)
        })
        .start()
      frameHandler = window.requestAnimationFrame(animate)
    }
  },
  mounted () {
    //  console.log(this.gradientBackground)
    this.tween(0, 360)
    window.setTimeout(() => {
      this.loading = false
    }, 200)
  },
  components: { TheKarta }
}
</script>

<style scoped>
.next {
  color: #fff;
  position: absolute;
  top: 3vh;
  left: 3.6vh;
  z-index: 999;
  font-size: 0.95em;
  letter-spacing: 0.5px;
}
.karta {
  position: absolute;
  left: 0px;
  bottom: 5vh;
  width: 100%;
}
* {
  box-sizing: border-box;
}
h1, p {
  margin: 0;
  max-width: calc(100% - 60px);
}
h1 {
  text-transform: uppercase;
  font-size: 1.2rem;
  letter-spacing: 1px;
  margin-bottom: 5px;
}
.darkness {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0;
  transition: all 1s ease-in;
}
.emoji {
  position: absolute;
  bottom: -12vw;
  width: 26vw;
  left: calc(50% - 13vw);
  height: 26vw;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 0px;
  font-size: 9vh;
  z-index: 99;
  text-shadow: 2px 2px 9px rgba(0, 0, 0, 0.1);
}
.view {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.top {
  background-color: pink;
  flex-grow: 1;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 50%;
  position: relative;
}
.bottom {
  height: 50%;
  background-color: #fff;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.answer-container, .question-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 1;
  transition: all 0.5s ease;
}
.question-container {
  position: relative;
  z-index: 100;
}
.loading .answer-container, .loading .question-container {
  opacity: 0;
}
.loading .question-container {
  transform: translateY(-20vh);
}
.loading .answer-container {
}
.reponses {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.response {
  flex-grow: 1;
  font-size: 6vh;
  font-weight: bold;
  text-transform: uppercase;
  color: #DB3254;
  letter-spacing: 2px;
  padding: 4px;
}
.nej, .ja {
}
.nej {
}
.ja {
}
.ja.active {
  transition: all 0.5s ease;
  transform: scale(1.8);
}
.nej.active {
  transition: all 0.5s ease;
  transform: scale(1.8);
}
.outline {
  color: #fff;
  -webkit-text-stroke: 2px #DB3254;
  /* text-shadow: -2px -2px 0 #DB3254, 2px -2px 0 #DB3254, -2px 2px 0 #DB3254, 2px 2px 0 #DB3254; */
}
.gradient-ani {
  transition: all 3s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionView.vue